// utils/connectionManager.ts
export const CloseCodes = {
    // --- Standard WebSocket / Colyseus layer ---
    1001: { displayMessage: "Browser Tab Closing", retryable: false },
    1002: { displayMessage: "Malformed frame received", retryable: false },
    1003: { displayMessage: "Unsupported frame received", retryable: false },
    1006: { displayMessage: "Ungraceful shutdown / connection refused", retryable: true, retryDelay: 2500 },
    1011: { displayMessage: "Internal Error", retryable: false },
    1012: { displayMessage: "Server Restarting", retryable: true, retryDelay: 4000 },
    1013: { displayMessage: "Try again later, server capacity full", retryable: true, retryDelay: 5000 },
    1014: { displayMessage: "Bad Gateway", retryable: true, retryDelay: 4000 },
    // --- Game server domain-specific codes ---
    4000: { displayMessage: "Gameserver graceful shutdown", retryable: false },
    4001: { displayMessage: "Room has been closed due to inactivity.", retryable: false },
    4002: { displayMessage: "Disconnected due to no host being connected.", retryable: false },
    4003: { displayMessage: "Disconnected due to host joining the wrong game.", retryable: false },
    4004: { displayMessage: "Disconnected due to no Host when connection established, force closing room.", retryable: false },
    4005: { displayMessage: "Disconnected due to no Host when client left, force closing room.", retryable: false },
    4050: { displayMessage: "Player removed", retryable: false },
};

// Default fallback if code not mapped
const DEFAULT_REASON = "Oops! Looks like something went wrong.";

// -------------------- Helpers --------------------

/** Is this code terminal? (don't retry) */
export function isTerminalByCode(code: number): boolean {
    return !CloseCodes[code]?.retryable;
}

/** Retry delay (ms) if retryable */
export function retryDelayForCode(code: number): number {
    return CloseCodes[code]?.retryDelay || 2000;
}

/** Human-friendly text for UI */
export function getCloseReasonText(code: number, fallbackMsg?: string): string {
    if (CloseCodes[code]?.displayMessage) return CloseCodes[code].displayMessage;
    return fallbackMsg || DEFAULT_REASON;
}

/** Regex-based heuristic for Colyseus reconnect errors (string messages, not codes) */
export function isTerminalReconnectError(err: any): boolean {
    // Check if it's a ProgressEvent (XMLHttpRequest error from failed HTTP request)
    // This happens when server is unreachable/crashed during matchmaking/reconnection
    if (err instanceof ProgressEvent && err.type === "error") {
        return true;
    }

    const msg = `${err?.message || ""}`.toLowerCase();

    // Check for connection refused errors (server crashed/unreachable)
    if (/err_connection_refused|connection\s*refused|econnrefused/.test(msg)) {
        return true;
    }

    // Check for room-related terminal errors
    return /not\s*found|room\s*not\s*found|disposed|room\s*disposed|expired|reconnection\s*token|invalid\s*room|invalid\s*reconnection|closed\s*room/.test(msg);
}